module.exports = __webpack_public_path__ + "static/media/58-iveco-mercedes.18e328e0.jpg";